import React from 'react';
import { motion } from 'framer-motion';

const WhyMatters = () => {
  return (
    <section className="pt-6 md:pt-8 pb-16 md:pb-24 bg-white" id="why-matters">
      <div className="container mx-auto px-4">
        <motion.div
          className="max-w-4xl mx-auto bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl border border-green-100 p-8 md:p-12 shadow-lg"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-[rgb(2,58,16)] mb-6 text-center">
            Why this matters to our farming partners
          </h2>
          <p className="text-lg md:text-xl text-gray-700 font-serif leading-relaxed text-center">
            Every challenge above was lived, not theorized. Three production cycles have shaped a farming
            operation that is leaner, more disciplined, and more resilient than where we started. This
            operational depth is what we bring to every new farming partnership.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyMatters;
